import {
  BarChart as RBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';
import { CHART_COLORS } from '../../config/constants';
import { useChartTheme } from '../../hooks/useChartTheme';

// data: [{ name, total }]. layout="vertical" => horizontal bars.
export function BarChart({ data, xKey = 'name', yKey = 'total', layout = 'horizontal', height = 320, onBarClick }) {
  const vertical = layout === 'vertical';
  const ct = useChartTheme();
  // Gradient runs along the bar's growth direction (→ for horizontal bars, ↓ for vertical).
  const gradId = (i) => `barGrad${vertical ? 'H' : 'V'}${i}`;
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RBarChart data={data} layout={layout} margin={{ top: 8, right: 16, bottom: 8, left: 0 }}>
        <defs>
          {CHART_COLORS.map((c, i) => (
            <linearGradient key={i} id={gradId(i)} x1="0" y1="0" x2={vertical ? '1' : '0'} y2={vertical ? '0' : '1'}>
              <stop offset="0%" stopColor={c} stopOpacity={0.95} />
              <stop offset="100%" stopColor={c} stopOpacity={0.55} />
            </linearGradient>
          ))}
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke={ct.grid} horizontal={!vertical} vertical={vertical} />
        {vertical ? (
          <>
            <XAxis type="number" tick={{ fontSize: 12, fill: ct.tick }} axisLine={false} tickLine={false} />
            <YAxis type="category" dataKey={xKey} tick={{ fontSize: 12, fill: ct.tick }} width={120} axisLine={false} tickLine={false} />
          </>
        ) : (
          <>
            <XAxis dataKey={xKey} tick={{ fontSize: 12, fill: ct.tick }} axisLine={{ stroke: ct.axis }} tickLine={false} />
            <YAxis tick={{ fontSize: 12, fill: ct.tick }} axisLine={false} tickLine={false} />
          </>
        )}
        <Tooltip contentStyle={ct.tooltip} itemStyle={{ color: ct.tooltip.color }} labelStyle={{ color: ct.tooltip.color }} formatter={(v) => Number(v).toLocaleString()} cursor={{ fill: ct.cursor }} />
        <Bar dataKey={yKey} radius={[6, 6, 6, 6]} onClick={onBarClick} cursor={onBarClick ? 'pointer' : 'default'}>
          {data?.map((_, i) => <Cell key={i} fill={`url(#${gradId(i % CHART_COLORS.length)})`} />)}
        </Bar>
      </RBarChart>
    </ResponsiveContainer>
  );
}
